import Dexie, { Table } from "dexie"

export type SongOffline = {
  url: string
  name: string
  artist: string
  songimg: string
  blob: Blob
  offline: "si"
  savedAt: Date
}

class OfflineDB extends Dexie {
  songs!: Table<SongOffline, string>

  constructor() {
    super("OfflineSongsDB")

    this.version(1).stores({
      songs: "&url,name,artist,savedAt,blob,offline,songimg",
    })
  }
}

export const db = new OfflineDB()
